import React from "react";

import { Link, Stack, Typography } from "@mui/material";

import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";
import { useBanner } from "./hooks";

const SiteBanner = () => {
  const textStyle = {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "18px",
    color: Colors.PrimaryContrast,
  };
  const linkStyle = {
    ...textStyle,
    textDecoration: "underline",
  };
  const { banner } = useBanner();

  if (!banner) {
    return null;
  }

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      alignItems="center"
      justifyContent="center"
      sx={{
        position: "relative",
        height: { xs: "unset", sm: "76px", md: "52px" },
        padding: { xs: "16px 24px", sm: "0 24px" },
        backgroundColor: Colors.BannerBackground,
        textAlign: { xs: "center", sm: "left" },
        zIndex: 100,
      }}
    >
      <Link href={banner?.url} underline="none" mr="8px">
        <Typography variant="body2" sx={textStyle}>
          {banner?.title}
        </Typography>
      </Link>
      <Link
        href={banner?.url}
        underline="always"
        ml={1}
        sx={{
          textAlign: { xs: "center", sm: "left" },
          whiteSpace: { xs: "unset", sm: "nowrap" },
        }}
      >
        <Typography variant="body2" sx={linkStyle}>
          {banner?.linkCta}
        </Typography>
      </Link>
    </Stack>
  );
};

export default SiteBanner;
